// extracted by mini-css-extract-plugin
module.exports = {"button":"Size_button__29BMg","sizes":"Size_sizes__qRuQa"};